<template>
  <div class="hm-rl">
    <div class="hm-rl__search">
      <HMSearch v-model="room_filter" id="room-search" />
    </div>
    <div v-if="page_loaded" class="hm-rl__content">
      <aside class="hm-rl__side">
        <div class="hm-rl__rooms">
          <div v-for="item in name_map" :key="item.items_key" class="hm-rl__list">
            <template v-if="filteredRooms[item.items_key].length">
              <div class="hm-rl__subt">
                <component :is="item.icon" aria-hidden="true"/>
                {{ item.label }}
              </div>
              <HMRoomsLink
                v-for="room in filteredRooms[item.items_key]"
                :key="room.id"
                :room="room"
              />
            </template>
          </div>
          <div
            v-if="!filteredRooms.checked_in.length && !filteredRooms.not_checked_in.length && !filteredRooms.checked_out.length"
            class="hm-rl__slug"
          >
            <div class="hm-rl__slug-pic">
              <img alt="Bed" src="@/assets/img/hm-bed.png" />
            </div>
            <div class="hm-rl__slug-title">No rooms found</div>
            <div class="hm-rl__slug-text">
              We couldn’t find any results matching your search. Please check your query and try again.
            </div>
          </div>
        </div>
      </aside>
      <div class="hm-rl__folio">
        <transition name="fade" mode="out-in">
          <router-view :room="currentRoom" @statusUpdated="fetchRooms" @fetchRoom="fetchRoom" />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import HMRoomsLink from '@/views/hotel-management/reservations/components/HMRoomsLink.vue'
import CheckIn from '@/views/hotel-management/reservations/detail/icons/CheckIn.vue'
import CheckOut from '@/views/hotel-management/reservations/detail/icons/CheckOut.vue'
import NotCheckIn from '@/views/hotel-management/reservations/detail/icons/NotCheckIn.vue'
import { getHotelManagementReservationsRooms } from '@/http'
import HMSearch from '@/views/hotel-management/reservations/components/HMSearch.vue'

export default {
  name: 'HotelManagementReservationsRoomsLayout',
  components: {
    HMSearch,
    HMRoomsLink,
    CheckIn,
    CheckOut,
    NotCheckIn
  },
  data() {
    return {
      page_loaded: false,
      room_filter: '',
      name_map: {
        checked_in: { icon: 'CheckIn', label: 'Checked In', items_key: 'checked_in' },
        not_checked_in: { icon: 'NotCheckIn', label: 'Not Checked In', items_key: 'not_checked_in' },
        checked_out: { icon: 'CheckOut', label: 'Checked Out', items_key: 'checked_out' },
      },
      checked_in_rooms: [],
      not_checked_in_rooms: [],
      checked_out_rooms: [],
      // currentRoom: null,
    }
  },
  computed: {
    filteredRooms() {
      return {
        checked_in: this.checked_in_rooms.filter(item => item.room.room_name.toLowerCase().includes(this.room_filter.toLowerCase())),
        not_checked_in: this.not_checked_in_rooms.filter(item => item.room.room_name.toLowerCase().includes(this.room_filter.toLowerCase())),
        checked_out: this.checked_out_rooms.filter(item => item.room.room_name.toLowerCase().includes(this.room_filter.toLowerCase())),
      }
    },
    currentRoom() {
      return [...this.checked_in_rooms, ...this.not_checked_in_rooms, ...this.checked_out_rooms]
        .find(item => item.id === Number(this.$route.params.roomId))
    }
  },
  // watch: {
  //   '$route.params.roomId': {
  //     handler(newParam) {
  //       this.currentRoom = [...this.checked_in_rooms, ...this.not_checked_in_rooms, ...this.checked_out_rooms]
  //         .find(item => item.id === Number(newParam))
  //     },
  //   }
  // },
  methods: {
    fetchRooms() {
      Promise.all([
        getHotelManagementReservationsRooms({ reservation: this.$route.params.id, status: 'checked_in' }),
        getHotelManagementReservationsRooms({ reservation: this.$route.params.id, status: 'not_checked_in' }),
        getHotelManagementReservationsRooms({ reservation: this.$route.params.id, status: 'checked_out' }),
      ])
        .then(res => {
          this.checked_in_rooms = res[0].data
          this.not_checked_in_rooms = res[1].data
          this.checked_out_rooms = res[2].data
        })
    },
    fetchRoom(status) {
      getHotelManagementReservationsRooms({ reservation: this.$route.params.id, status })
        .then(res => {
          this[`${status}_rooms`] = res.data
        })
    }
  },
  created() {
    Promise.all([
      getHotelManagementReservationsRooms({ reservation: this.$route.params.id, status: 'checked_in' }),
      getHotelManagementReservationsRooms({ reservation: this.$route.params.id, status: 'not_checked_in' }),
      getHotelManagementReservationsRooms({ reservation: this.$route.params.id, status: 'checked_out' }),
    ])
      .then(res => {
        this.checked_in_rooms = res[0].data
        this.not_checked_in_rooms = res[1].data
        this.checked_out_rooms = res[2].data
        // if (this.$route.params.roomId) {
        //   this.currentRoom = [...this.checked_in_rooms, ...this.not_checked_in_rooms, ...this.checked_out_rooms]
        //     .find(item => item.id === Number(this.$route.params.roomId))
        // }
        this.page_loaded = true
      })
  },
}
</script>

<style scoped>
.hm-rl__content {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 20px;
}

.hm-rl__search {
  margin-bottom: 27px;
}

.hm-rl__subt {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 7px;
  color: #000;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 15px;
  font-weight: 600;
}

.hm-rl__list {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 20px;

  &:last-child,
  &:empty {
    margin-bottom: 0;
  }
}

.hm-rl__folio {
  margin-top: 32px;
}

.hm-rl__slug {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 15px;
  border-radius: 16px;
  border: 1px solid #E5ECF3;
  background-color: #FCFDFE;
}

.hm-rl__slug-pic {
  width: 96px;
  height: 96px;
  margin-bottom: 16px;
  line-height: 1;
}

.hm-rl__slug-title {
  margin-bottom: 16px;
  color: #6997A1;
  text-align: center;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 16px;
  font-weight: 500;
}

.hm-rl__slug-text {
  color: #A5B2B8;
  text-align: center;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 13px;
  font-weight: 500;
}
</style>
